import { render } from "./PhonesSection.vue?vue&type=template&id=0429ca35"
import script from "./PhonesSection.vue?vue&type=script&lang=js"
export * from "./PhonesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__